import { AgentKnowledgeStatus } from "@redotech/cockroachdb-codegen/tables/agent-knowledge/agent-knowledge-status";
import { accountIdFormat } from "@redotech/redo-account-id";
import { productFamilyIdFormat } from "@redotech/redo-product-id";
import { productKnowledgeIdFormat } from "@redotech/shopper-agent-knowledge-id";
import * as z from "zod";
import { referencedProductFamilySchema } from "./merchant-knowledge-view";

// Content shared across several products without duplicating it. Injected on
// product lookup, so its links are what make it reachable at all.

/**
 * What a merchant authors. At least one product is required: an entry no
 * product points at can never be injected.
 */
export const productKnowledgeDraftSchema = z.object({
  content: z.string(),
  productFamilyIds: z.array(productFamilyIdFormat.schema).min(1),
});
export type ProductKnowledgeDraft = z.infer<typeof productKnowledgeDraftSchema>;

export const productKnowledgeEntrySchema = z.object({
  id: productKnowledgeIdFormat.schema,
  accountId: accountIdFormat.schema,
  status: z.enum(AgentKnowledgeStatus),
  content: z.string(),
  /**
   * Hydrated for display. Soft-deleted families drop out, so this can be empty
   * even though a save required one.
   */
  products: z.array(referencedProductFamilySchema),
  createdAt: z.date(),
  updatedAt: z.date(),
});
export type ProductKnowledgeEntry = z.infer<typeof productKnowledgeEntrySchema>;

export const productKnowledgeListItemSchema = productKnowledgeEntrySchema
  .omit({ content: true })
  .extend({ contentPreview: z.string() });
export type ProductKnowledgeListItem = z.infer<
  typeof productKnowledgeListItemSchema
>;
